(() => {
  const gridSelector = '.product-grid, .resource-list, .loving-edit__grid, .fr-edit-grid';
  let timer;
  const fields = [
    ['--fr-card-title-height', '[ref="productTitleLink"] .text-block, .loving-look-card__copy h3, .fr-edit-card-copy h3'],
    ['--fr-card-description-height', '.loving-look-card__meta p'],
    ['--fr-card-rating-height', '.product-card__content > div:has(.loving-air-reviews-stars--card)']
  ];
  function align() {
    document.querySelectorAll(gridSelector).forEach(grid => {
      const cards = [...grid.querySelectorAll('product-card, .loving-look-card, .fr-edit-card')].filter(card => card.closest(gridSelector) === grid && card.getBoundingClientRect().width > 0);
      // Reset before measuring, then batch every read ahead of final writes.
      cards.forEach(card => fields.forEach(([name]) => { if (card.style.getPropertyValue(name)) card.style.removeProperty(name); }));
      const rows = [];
      cards.forEach(card => {
        const top = card.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 3);
        if (!row) rows.push(row = {top, cards: []});
        row.cards.push(card);
      });
      const updates = [];
      rows.forEach(row => fields.forEach(([name, selector]) => {
        const height = Math.ceil(Math.max(0, ...row.cards.map(card => card.querySelector(selector)?.getBoundingClientRect().height || 0)));
        row.cards.forEach(card => updates.push([card, name, `${height}px`]));
      }));
      updates.forEach(([card, name, value]) => card.style.setProperty(name, value));
    });
  }
  function queue() { clearTimeout(timer); timer = setTimeout(() => requestAnimationFrame(align), 120); }
  addEventListener('resize', queue, {passive: true});
  addEventListener('load', queue);
  document.fonts.ready.then(queue);
  document.querySelectorAll('.loving-mobile-menu').forEach(menu => {
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector(':scope > summary').focus(); }
    });
    document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
  });
  new MutationObserver(mutations => {
    if (mutations.some(m => m.target.nodeType === 1 && (m.target.closest(gridSelector) || [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches(gridSelector) || n.querySelector(gridSelector)))))) queue();
  }).observe(document.body, {childList: true, subtree: true});
  queue();
})();
